export default __webpack_public_path__ + "static/media/fr-asia-7.aa295703.jpg";